import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { formatINR, formatDate } from "../../lib/format";
import StatusBadge from "../../components/StatusBadge";
import { EditModeToggle } from "../../components/editor/EditModeToggle";
import { useEditModeSession } from "../../hooks/useEditModeSession";

export default function TenantHome() {
  const { isInEditMode } = useEditModeSession();
  const [rentals, setRentals] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/rentals"); setRentals(data); })(); }, []);

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className={isInEditMode ? "edit-mode-active" : ""}>
      <EditModeToggle pageId="tenant_dashboard" />

      <div className="space-y-6" data-testid="tenant-home">
      <div>
        <h1 className="text-3xl font-bold font-display">My Rentals</h1>
        <p className="text-sm text-gray-500 mt-1">All your rental agreements, in one place.</p>
      </div>
      {rentals.length === 0 ? (
        <div className="card-base p-12 text-center" data-testid="empty-state">
          <p className="text-gray-600 text-lg">Your broker will add you to a rental.</p>
          <p className="text-sm text-gray-400 mt-1">Nothing to do yet.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {rentals.map((r) => {
            const needsSignature = r.status === "agreement_pending" && r.agreement && !(
              r.agreement.tenant_signatures?.find(sig => sig.tenant_id === currentUser.id)?.signed_at
            );
            return (
              <Link key={r.id} to={`/app/rental/${r.id}`} className="card-base p-6 block hover:shadow-md transition-shadow" data-testid="active-rental-card">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-widest">{r.property_type}</div>
                    <div className="mt-1 text-2xl font-bold font-display">{r.property_address}</div>
                    <div className="mt-1 text-sm text-gray-500">Lease ends {formatDate(r.lease_end_date)}</div>
                    {needsSignature && (
                      <div className="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-lg">
                        <span className="text-amber-600">⏰</span>
                        <span className="text-xs font-medium text-amber-700">Your signature needed</span>
                      </div>
                    )}
                  </div>
                  <StatusBadge status={r.status} />
                </div>
                <div className="mt-6 grid grid-cols-3 gap-4 pt-6 border-t">
                  <div>
                    <div className="text-xs text-gray-500">Monthly rent</div>
                    <div className="font-semibold">{formatINR(r.monthly_rent)}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Deposit</div>
                    <div className="font-semibold">{formatINR(r.deposit_amount)}</div>
                  </div>
                  <div>
                    <div className="text-xs text-gray-500">Owner</div>
                    <div className="font-semibold">{r.landlord?.name}</div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
      </div>
    </div>
  );
}
